// src/services/kbServices.js
import request from './requestServices';
import { API_KB_LIST_URL } from './apiRoutes';

export async function listKnowledgeBases(project_id) {
  let url = API_KB_LIST_URL;
  if (project_id) {
    url += `?project_id=${encodeURIComponent(project_id)}`;
  }
  const { data } = await request(url, {
    method: 'GET',
  });
  // The updated API returns: { RetCode:0, data:{kbs:[],...}}
  return data.data?.kbs || [];
}



